// extracted by mini-css-extract-plugin
module.exports = {"art":"SliderCollection_art__AjVAF","icon":"SliderCollection_icon__NKFLV"};